import styled from "styled-components";

export const MainContainer = styled.div`
  border-left: 1px solid #dfe3e8;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;

  @media (max-width: 768px) {
    border-left: none;
  }
`;

export const InnerContainer = styled.div`
  padding-left: 40px;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding-left: 0;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 12px;
  flex-wrap: wrap;
`;

export const PageTitle = styled.h2`
  font-family: "Syne", sans-serif;
  font-size: 22px;
  font-weight: 800;
  color: #111;
  margin: 0 0 4px;
`;

export const PageSub = styled.p`
  font-size: 13px;
  color: #9ca3af;
  font-weight: 300;
  margin: 0;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PeriodSelect = styled.select`
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 12px;
  color: #374151;
  font-family: "Inter", sans-serif;
`;

export const ExportBtn = styled.button`
  background: #e8521a;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 20px;
  min-width: 0;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const Kpi = styled.div`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 12px;
  padding: 18px 16px;
`;

export const KpiLabel = styled.div`
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  font-weight: 500;
`;

export const KpiValue = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 26px;
  font-weight: 800;
  color: #111;
  margin-bottom: 4px;
  line-height: 1;
`;

export const KpiChange = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: ${(p) => (p.$down ? "#dc2626" : "#16a34a")};
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: ${(p) => p.$cols || "1fr 1fr"};
  gap: 16px;
  margin-bottom: 16px;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 12px;
  padding: 20px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
`;

export const CardTitle = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #111;
`;

export const CardSub = styled.div`
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
`;

export const TinyText = styled.span`
  font-size: 12px;
  color: #e8521a;
  cursor: pointer;
  font-weight: 500;
`;

export const BarChart = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  height: 160px;
`;

export const BarGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1;
`;

export const BarValue = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: #374151;
`;

export const BarWrap = styled.div`
  display: flex;
  align-items: flex-end;
  height: 120px;
  width: 100%;
`;

export const Bar = styled.div`
  border-radius: 5px 5px 0 0;
  width: 100%;
  height: ${(p) => p.$height || 10}%;
  background: ${(p) =>
    p.$highlight
      ? "linear-gradient(180deg,#ff8c5a,#E8521A)"
      : "linear-gradient(180deg,#fdd0c0,#E8521A)"};
`;

export const BarLabel = styled.div`
  font-size: 10px;
  color: ${(p) => (p.$highlight ? "#E8521A" : "#9ca3af")};
  font-weight: ${(p) => (p.$highlight ? 600 : 400)};
`;

export const BreakdownList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BreakdownRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px 70px;
  gap: 8px;
  align-items: center;
  min-width: 0;

  @media (max-width: 480px) {
    grid-template-columns: minmax(0, 1fr) auto auto;
    gap: 6px;
  }
`;

export const BreakdownLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(p) => p.$color || "#ddd"};
`;

export const BreakdownName = styled.span`
  min-width: 70px;
  font-size: 12px;
  color: #374151;
  font-weight: 500;
`;

export const MiniBarWrap = styled.div`
  flex: 1;
  height: 5px;
  background: #f0f0f0;
  border-radius: 999px;
  overflow: hidden;
`;

export const MiniBarFill = styled.div`
  height: 100%;
  width: ${(p) => p.$pct || 0}%;
  border-radius: 999px;
  background: ${(p) => p.$color || "#e8521a"};
`;

export const BreakdownPct = styled.span`
  font-size: 11px;
  color: #9ca3af;
  text-align: right;
`;

export const BreakdownAmount = styled.span`
  font-family: "Syne", sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #111;
  text-align: right;
`;

export const AovBig = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 40px;
  font-weight: 800;
  color: #111;
  margin: 8px 0 4px;
`;

export const AovDelta = styled.div`
  font-size: 11px;
  color: #16a34a;
  margin-bottom: 12px;
  font-weight: 500;
`;

export const TxTableScroll = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    margin: 0 -4px;
    padding: 0 4px;
  }
`;

export const TxTable = styled.table`
  width: 100%;
  min-width: 520px;
  border-collapse: collapse;
  th {
    font-size: 10px;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 600;
    padding: 6px 8px;
    text-align: left;
    border-bottom: 1px solid #f5f5f5;
  }
  td {
    font-size: 12px;
    color: #374151;
    padding: 8px 8px;
    border-bottom: 1px solid #f9f9f9;
    vertical-align: middle;
  }
  th:nth-child(6),
  td:nth-child(6) {
    white-space: nowrap;
    min-width: 112px;
  }
  tr:last-child td {
    border-bottom: none;
  }
`;

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
  line-height: 1.2;
  background: ${(p) => p.$bg || "#f3f4f6"};
  color: ${(p) => p.$color || "#374151"};
`;
